import { createSlice } from "@reduxjs/toolkit";
import { DeleteProperty, GetProperties, CreateProrperty } from "./propertyActions";

const initialState = {
    properties: [],
    loading: false,
    error: null,
    selectedProperty: null,
    openPropertyModal: false
};

const propertiesSlice = createSlice({
    name: 'properties',
    initialState,
    reducers: {
        setOpenCreateProperty: (state) => {
            state.openPropertyModal = true
        },
        setCloseCreateProperty: (state) => {
            state.openPropertyModal = false
        },
        setSelectedProperty: (state, { payload }) => {
            state.selectedProperty = payload
        },
        addNewProperty: (state, { payload }) => {
            let latestProperties:any = [...state.properties, payload?.data];
            state.properties= latestProperties;
        },
        removeProperty: (state, { payload }) => {
            let latestProperties:any = [...state.properties].filter((p:any)=>p?._id !== payload);
            state.properties= latestProperties;
        },
        updateProperty: (state, { payload }:any) => {
            let latestProperties:any = [...state.properties];
            let index:any = [...state.properties].findIndex((p:any)=>p?._id !== payload?.data?._id);
            latestProperties.splice(index, 1, payload?.data);
            state.properties= latestProperties;
        }
    },
    extraReducers: (builder: any) => {
        builder
            .addCase(GetProperties.pending, (state: any) => {
                state.loading = true;
                state.error = null; // Reset error on pending request
            })
            .addCase(GetProperties.fulfilled, (state: any, action: any) => {
                state.loading = false;
                state.properties = action.payload.data;
            })
            .addCase(GetProperties.rejected, (state: any, action: any) => {
                state.loading = false;
                state.error = action.payload ? action.payload.error : "Failed to load properties";
            });
    },
});

const createProperties = createSlice({
    name: 'CreateProperty',
    initialState,
    reducers: { },
    extraReducers: (builder: any) => {
        builder
            .addCase(CreateProrperty.pending, (state: any) => {
                state.loading = true;
                state.error = null; // Reset error on pending request
            })
            .addCase(CreateProrperty.fulfilled, (state: any, { payload }) => {
                    state.loading = false;
            })
            .addCase(CreateProrperty.rejected, (state: any, action: any) => {
                state.loading = false;
            });
    }

});

const deleteProperty = createSlice({
    name: 'deleteProperty',
    initialState,
    reducers: {},
    extraReducers: (builder: any) => {
        builder
            .addCase(DeleteProperty.pending, (state: any) => {
                state.loading = true;
                state.error = null; // Reset error on pending request
            })
            .addCase(DeleteProperty.fulfilled, (state: any, action: any) => {
                state.loading = false;
            })
            .addCase(DeleteProperty.rejected, (state: any, action: any) => {
                state.loading = false;
            });
    },
});
export const { setOpenCreateProperty, setCloseCreateProperty, setSelectedProperty,
    addNewProperty, updateProperty, removeProperty
 } = propertiesSlice.actions;

export const properties = propertiesSlice.reducer;
export const deletePropertySlice = deleteProperty.reducer;
export const createPropertySlice = createProperties.reducer;


